import pick from 'lodash/pick'

export const SETUP_WIZARDS = {
  // BRANCH_WIZARD: 'BRANCH_WIZARD',

  // MENU_SELLING_TYPES: 'MENU_SELLING_TYPES',
  SERVICES: 'SERVICES',
  PAYMENT_METHODS: 'PAYMENT_METHODS',

  MENU: 'MENU',
  POS: 'POS',
  MODIFIERS: 'MODIFIERS',
  CLOUD: 'CLOUD',
  TAXES: 'TAXES',

  // SCHEDULED_ORDERS: 'SCHEDULED_ORDERS',
  USERS_WIZARD: 'USERS_WIZARD',

  QR_CODE: 'QR_CODE',
  DEVICES: 'DEVICES',
  WIDGET: 'WIDGET',
  DOMAIN: 'DOMAIN',
  GOOGLE_MENU: 'GOOGLE_MENU',

  DESIGN_QR: 'DESIGN_QR',
  DESIGN_TABLET: 'DESIGN_TABLET',

  SURVEY: 'SURVEY',
  COUPONS: 'COUPONS',
  PROMOTIONS: 'PROMOTIONS',
  // MARKETING_EVENTS: 'MARKETING_EVENTS',
  // CAMPAIGN: 'CAMPAIGN',
  DISCOUNTS: 'DISCOUNTS',
  NEWSLETTER: 'NEWSLETTER',
}

export const WIZARD_SECTIONS: any = {
  // ACCOUNT_BASIC: [SETUP_WIZARDS.BRANCH_WIZARD],
  ORDERING: [SETUP_WIZARDS.SERVICES, SETUP_WIZARDS.PAYMENT_METHODS],
  MENU: [SETUP_WIZARDS.MENU, SETUP_WIZARDS.MODIFIERS, SETUP_WIZARDS.CLOUD],
  ORGANIZING: [SETUP_WIZARDS.USERS_WIZARD],
  PUBLISHING: [SETUP_WIZARDS.QR_CODE, SETUP_WIZARDS.DEVICES, SETUP_WIZARDS.WIDGET, SETUP_WIZARDS.DOMAIN, SETUP_WIZARDS.GOOGLE_MENU],
  DESIGN: [SETUP_WIZARDS.DESIGN_QR, SETUP_WIZARDS.DESIGN_TABLET],
  MARKETING: [SETUP_WIZARDS.SURVEY, SETUP_WIZARDS.COUPONS, SETUP_WIZARDS.DISCOUNTS, SETUP_WIZARDS.NEWSLETTER],
}

const SETUP_WIZARDS_STEPS: any = {
  BRANCH_WIZARD: {
    steps: ['basic_info', 'branch_address', 'menu_language'],
    stepsNames: ['branch.basic-info', 'branch.branch-address', 'branch.menu-languages-currency'],
    route: 'admin:branch-wizard',
  },
  // MENU_SELLING_TYPES: {
  //   steps: ['selling_types', 'menu_types', 'dine_in', 'delivery'],
  //   stepsNames: ['selling-types.selling-types', 'selling-types.menu-types', 'selling-types.types.product-service', 'dinein.dinein', 'delivery.delivery'],
  //   route: 'admin:selling-types-wizard',
  // },
  SERVICES: {
    steps: ['dine_in', 'pickup', 'delivery', 'queue', 'reservation'],
    stepsNames: ['dinein.dinein', 'pickup.pickup', 'delivery.delivery', 'queue.get-queue', 'queue.reservation'],
    route: 'admin:services-wizard',
  },
  PAYMENT_METHODS: {
    steps: ['payment_method'],
    stepsNames: ['payment-methods.payment-methods'],
    route: 'admin:payment-methods-wizard',
  },
  MENU: {
    steps: ['menu'],
    stepsNames: ['my-menu.my-menu'],
    route: 'admin:my-menu',
  },
  POS: {
    steps: [],
    stepsNames: ['my-menu.pos-menu.title'],
    route: 'admin:pos-menu',
  },
  MODIFIERS: {
    steps: ['add_modifier', 'show_modifiers'],
    stepsNames: ['modifiers.add-first-group', 'modifiers.modifiers'],
    route: 'admin:modifiers',
  },
  CLOUD: {
    steps: ['cloud_list'],
    stepsNames: ['cloud.okmenu-cloud'],
    route: 'admin:cloud',
  },
  // QUEUE_RESERVATION: {
  //   steps: ['queue', 'reservation'],
  //   stepsNames: ['queue.get-queue', 'queue.reservation'],
  //   route: 'admin:queue-reservation',
  // },
  // OPENING_HOURS: {
  //   steps: ['opening_hours'/* 'special_hours' */],
  //   stepsNames: ['shifts.opening-hours'],
  //   route: 'admin:opening-hours-wizard',
  // },
  // SCHEDULED_ORDERS: {
  //   steps: ['scheduled_orders'],
  //   stepsNames: ['scheduled-orders.scheduled-orders'],
  //   route: 'admin:scheduled-orders',
  // },
  USERS_WIZARD: {
    steps: ['update_admin_email_notifications', 'users_list', 'activity_list'],
    stepsNames: ['navigation.users-notifications', 'activity-logs.activity-logs'],
    route: 'admin:users-wizard',
  },
  QR_CODE: {
    steps: ['qr_code', 'qr_code_list'],
    stepsNames: ['qr.qr_code'],
    route: 'admin:qr',
  },
  DEVICES: {
    steps: ['download-app', 'add-device', 'devices-list'],
    stepsNames: ['devices.title'],
    route: 'admin:devices',
  },
  WIDGET: {
    steps: ['enable_widget', 'add_widget', 'copy_widget'],
    stepsNames: ['widget.title'],
    route: 'admin:widget',
  },
  DOMAIN: {
    steps: ['domain_type', 'domain_chose'],
    stepsNames: ['domain.title'],
    route: 'admin:domain',
  },
  GOOGLE_MENU: {
    steps: ['viral_question', 'viral_existed', 'viral_store_code', 'viral_form', 'viral_level', 'viral_verification'],
    stepsNames: ['google-menu.title'],
    route: 'admin:google-menu',
  },
  DESIGN_QR: {
    steps: ['design_qr_question', 'design_qr_list'],
    stepsNames: ['design.qr.qr-menu-themes', 'design.qr.qr-menu-themes'],
    route: 'admin:design:qr',
  },
  DESIGN_TABLET: {
    steps: ['design_tablet_question', 'design_tablet_list'],
    stepsNames: ['design.tablet.ipad-menu-themes', 'design.tablet.ipad-menu-themes'],
    route: 'admin:design:tablet',
  },
  SURVEY: {
    steps: ['survey_question', 'surveys_list', 'surveys_replies'],
    stepsNames: ['surveys.title', 'surveys.title', 'surveys.replies-title'],
    route: 'admin:surveys',
  },
  COUPONS: {
    steps: ['coupons', 'coupons_list'],
    stepsNames: ['coupons.title'],
    route: 'admin:coupons',
  },
  PROMOTIONS: {
    steps: ['promotions', 'promotions_list'],
    stepsNames: ['promotions.title'],
    route: 'admin:promotions',
  },
  // CAMPAIGN: {
  //   steps: ['campaigns', 'campaigns_list'],
  //   stepsNames: ['campaigns.title'],
  //   route: 'admin:campaigns',
  // },
  DISCOUNTS: {
    steps: ['discounts', 'discounts_list'],
    stepsNames: ['discounts.title'],
    route: 'admin:discounts',
  },
  NEWSLETTER: {
    steps: ['newsletter_question', 'newsletter_list', 'subscribers_list'],
    stepsNames: ['newsletters.title', 'newsletters.subscribers'],
    route: 'admin:newsletters',
  },
}

export const BASE_SETUP_WIZARDS = [
  // SETUP_WIZARDS.BRANCH_WIZARD,
  SETUP_WIZARDS.SERVICES,
  SETUP_WIZARDS.PAYMENT_METHODS,
  SETUP_WIZARDS.USERS_WIZARD,
  SETUP_WIZARDS.MENU,
  SETUP_WIZARDS.MODIFIERS,
  SETUP_WIZARDS.QR_CODE,
  SETUP_WIZARDS.DEVICES,
  SETUP_WIZARDS.WIDGET,
  SETUP_WIZARDS.DOMAIN,
  SETUP_WIZARDS.GOOGLE_MENU,
]

const tabletWizards = [SETUP_WIZARDS.DEVICES, SETUP_WIZARDS.DESIGN_TABLET]
export const TABLET_STEPS = Object.values(pick(SETUP_WIZARDS_STEPS, tabletWizards)).reduce((prev: any, { steps }: any) => ([...prev, ...steps]), ['reservation'])

export const BASE_SETUP_STEPS = BASE_SETUP_WIZARDS.reduce((prev: any[], wizard: string) => [...prev, ...SETUP_WIZARDS_STEPS[wizard].steps], [])

export default SETUP_WIZARDS_STEPS
